"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 接口模块
var _default = exports.default = {
  getInterfaceUserList: function getInterfaceUserList(data) {
    return (0, _request.default)({
      url: '/protected/apiUser/list',
      method: 'post',
      data: data
    });
  },
  getInterfaceUserDetail: function getInterfaceUserDetail(id) {
    return (0, _request.default)({
      url: '/protected/apiUser/query/' + id,
      method: 'get'
    });
  },
  saveInterfaceUser: function saveInterfaceUser(data) {
    return (0, _request.default)({
      url: '/protected/apiUser/save',
      method: 'post',
      data: data
    });
  },
  deleteInterfaceUser: function deleteInterfaceUser(data) {
    return (0, _request.default)({
      url: '/protected/apiUser/delete',
      method: 'post',
      data: data
    });
  },
  enableInterfaceUser: function enableInterfaceUser(id) {
    return (0, _request.default)({
      url: '/protected/apiUser/enable/' + id,
      method: 'get'
    });
  },
  disableInterfaceUser: function disableInterfaceUser(id) {
    return (0, _request.default)({
      url: '/protected/apiUser/disabled/' + id,
      method: 'get'
    });
  },
  resetTokenInterfaceUser: function resetTokenInterfaceUser(id) {
    return (0, _request.default)({
      url: '/protected/apiUser/resetToken/' + id,
      method: 'get'
    });
  },
  viewTokenInterfaceUser: function viewTokenInterfaceUser(id) {
    return (0, _request.default)({
      url: '/protected/apiUser/viewToken/' + id,
      method: 'get'
    });
  },
  authInfosInterfaceUser: function authInfosInterfaceUser(id, data) {
    return (0, _request.default)({
      url: '/protected/apiUser/authInfos/' + id,
      method: 'post',
      data: data
    });
  },
  authSaveInterfaceUser: function authSaveInterfaceUser(data) {
    return (0, _request.default)({
      url: '/protected/apiUser/authSave',
      method: 'post',
      data: data
    });
  }
};